import PropTypes from 'prop-types';
import React from 'react';
import {connect, useDispatch} from 'react-redux';
import {notify} from '@actions/notifications';
import {useTranslation} from 'react-i18next';

import {Divider, MenuItem} from '@mui/material';

import useCollectionParams from '@app/hooks/useCollectionParams';
import useOrgParams from '@app/hooks/useOrgParams';
import {
  HelpMenu as HelpMenuComponent,
  NavMenuLink as MenuLink,
} from '@apps-common/ui-components/NavBar';
import {TOURS} from '@app/constants/tour';
import {isUsersOrg} from '@app/util/user';
import {startTour} from '@app/actions/tour';
import {trackEvent} from '@app/analytics';
import {useAuth} from '@apps-common/auth-react';
import {useGetCollectionsCount} from '@app/api/collections';

const HelpMenu = ({startTour, ...props}) => {
  const auth = useAuth();
  const {t} = useTranslation();
  const {orgId} = useOrgParams();
  const {data: totalCollections} = useGetCollectionsCount(orgId);
  const {resetCollection} = useCollectionParams();
  const dispatch = useDispatch();
  const NO_ORG_ACCESS_ERR_KEY = 'no-org-access';
  const user = auth.user;
  const isUserOrg = isUsersOrg(user?.claims, orgId);

  const onTourStart = () => {
    if (!isUserOrg) {
      dispatch(
        notify({
          message: t('tourDialog.switchOrgs', {orgId}),
          severity: 'warning',
          persist: true,
          key: NO_ORG_ACCESS_ERR_KEY,
        })
      );
    } else if (totalCollections === 0) {
      startTour(TOURS.EMPTY_STATE);
    } else {
      resetCollection();
      setTimeout(() => {
        startTour(TOURS.COLLECTION_TOUR_PT1);
      }, 300);
    }

    trackEvent('Tour', {
      action: 'Started',
    });
  };

  return (
    <HelpMenuComponent {...props}>
      <MenuItem onClick={onTourStart} data-testid="take-tour">
        {t('navbars.menuTour')}
      </MenuItem>
      <Divider />
      <MenuLink
        href="https://community.planet.com/ideas"
        data-testid="leave-feedback-link"
      >
        {t('navbars.menuFeedback')}
      </MenuLink>
    </HelpMenuComponent>
  );
};

HelpMenu.propTypes = {
  startTour: PropTypes.func,
};

const mapDispatchProps = {
  startTour,
};

export default connect(null, mapDispatchProps)(HelpMenu);
